(function() {
	'use strict';

	/**
	* @memberof app
	* @ngdoc controller
	* @name AppController
	* @description
	* This is main controller
	**/

	angular
		.module('app')
		.controller('AppController', AppController);

	AppController.$inject = ["CarritoService", "$timeout", "$location", '$window', 'DatosService',"$scope"];

	function AppController(CarritoService, $timeout, $location, $window, DatosService,$scope) {
		var vm = this;
		vm.carritoService = CarritoService;
		vm.cantidades = {};
		vm.carritoService.sumaCarrito = "";
		vm.carritoCargado = false;
		vm.productoscarrito = [];

		function addCustomProduct() {
			// console.log(vm.productoscarrito); // true
			vm.addProduct("2045", "product")

		}

		vm.getCarrito = function() {
			CarritoService.getCarrito(function(data) {
				const oldNumCart = vm.num_cart;

				vm.num_cart = data.sumaCarrito;
				vm.numberprod = data.sumaCarrito;
				vm.carrito = data.carrito;
				vm.carritoService.sumaCarrito = data.precioCarrito;
				vm.carritoService.sumaTotal = data.precioCarritoTotal;

				vm.productoscarrito = []; 
				for (var i = 0; i < vm.carrito.length; i++) {
					vm.productoscarrito.push({ id: vm.carrito[i].id, title: vm.carrito[i].product.title })
				}

				vm.productoscarrito = JSON.stringify(vm.productoscarrito);
				vm.carritoCargado = true;

				// ESTO ES PARA UNA ANIMACION
				if (oldNumCart !== data.sumaCarrito) {
					vm.animateNumCart = true;
					setTimeout(function() {
						vm.animateNumCart = false;
						if (!$scope.$$phase) $scope.$apply(); // Por si estás fuera del digest cycle
					}, 500); // debe coincidir con la duración de la animación CSS
				}

			});
		}
		vm.getCarrito();

		vm.addProduct = function(car_id, content_type) {
			vm.pedidoenviado = false;
			CarritoService.newprodcart(car_id, content_type, function(data) {
				vm.cart = data.cart;
				vm.getCarrito();
			});
		}

		vm.deleteOneProduct = function(car_id, content_type) {
			CarritoService.deleteProdcart(car_id, content_type, function(data) {
				vm.cart = data.cart;
				vm.getCarrito();
			});
		}

		window.addEventListener('formularioEnviadoOk', function() {
			vm.getCarrito(); 
			$scope.$apply();
		});

	}
	
})();

